import React from "react";
import { baseInfoModel } from "../baseInfoModel";
import { ISearchValue, SearchTypeEnum, TreeDsType } from "@src/components/YhPageHeader/Types";
import { YhPageHeader } from "@src/components/YhPageHeader";

export function BasicPageHeader() {
  const {
    searchParam,
    initPgCfg,
    updateSearchParam,
    resetSearchParam,
    loadData,
    educationalTypeDs, orgDs, hukouTypeDs, baseTypeDs
  } = baseInfoModel();

  const searchFields = [
    {
      type: SearchTypeEnum.Input,
      xxl: 3,
      span: 3,
      placeholder: "姓名",
      fieldName: "name",
      size: "small",
      disabled: false
    },
    {
      type: SearchTypeEnum.Input,
      xxl: 3,
      span: 3,
      placeholder: "员工工号",
      fieldName: "staffId",
      size: "small",
      disabled: false
    },
    {
      type: SearchTypeEnum.TreeSelect,
      xxl: 4,
      span: 4,
      placeholder: "所属机构",
      fieldName: "orgCode",
      size: "small",
      disabled: false,
      treeDs: orgDs as unknown as TreeDsType[]
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 2,
      span: 2,
      placeholder: "办公基地",
      fieldName: "dormitory",
      size: "small",
      options: baseTypeDs,
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 2,
      span: 2,
      placeholder: "学历",
      fieldName: "education",
      size: "small",
      disabled: false,
      options: educationalTypeDs
    },
    {
      type: SearchTypeEnum.Input,
      xxl: 3,
      span: 3,
      placeholder: "毕业院校",
      fieldName: "graduationSchool",
      size: "small",
      disabled: false
    },
    {
      type: SearchTypeEnum.Input,
      xxl: 3,
      span: 3,
      placeholder: "驾驶证",
      fieldName: "certificateName",
      size: "small",
      disabled: false
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 2,
      span: 2,
      placeholder: "状态",
      fieldName: "status",
      size: "small",
      disabled: false,
      options: [
        { label: "启用", value: 0 },
        { label: "禁用", value: 1 }
      ]
    },
    {
      type: SearchTypeEnum.Select,
      xxl: 2,
      span: 2,
      placeholder: "性别",
      fieldName: "gender",
      size: "small",
      disabled: false,
      options: [{ value: 1, label: '男' }, { value: 2, label: '女' }]
    },
    // {
    //   type: SearchTypeEnum.Select,
    //   xxl: 2,
    //   span: 2,
    //   placeholder: "户口性质",
    //   fieldName: "residenceType",
    //   size: "small",
    //   disabled: false,
    //   options: hukouTypeDs
    // },
  ]

  return (
    <YhPageHeader
      triggerSearch={true}
      searchValues={searchParam as ISearchValue}
      searchFields={searchFields}
      onChange={updateSearchParam}
      handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
      handleReset={resetSearchParam}
    />
  );
}